import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import StandaloneToolbar from './StandaloneToolbar';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../pages/Timesheets/CustomStyles/StyledTable';
import GenericLoader from '../../Loader/GenericLoader';
import {
  ERROR_KEY,
  TimesheetsComponentLoaderAttribute,
} from '../../../constants';
import ReportIcon from '@mui/icons-material/Report';
import { DARK_RED } from '../../../color';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const WorkPayrollSummary = (props) => {
  const {
    loader,
    totalHours,
    officeHours,
    reportedWfhHours,
    approvedWfhHours,
    pendingRemoteOfficeHours,
    approvedRemoteOfficeHours,
    externalHours,
    clientOfficeHours,
    workTravelHours,
    weekendWorkingHours,
    expectedHours,
    payrollPercentage,
    leavesAvailed,
    onNavigate,
    label,
  } = props;

  function createData(name, values) {
    return { name, values };
  }

  const safeValue = (value) => (isNaN(value) || value == null ? 0 : value);

  const hasHours = (value) => {
    if (value == null || value === '') return false;
    const text = String(value).trim();
    return text !== '' && text !== '0 min' && text !== '0 min ';
  };

  const rows = [
    createData('Expected Hours', expectedHours),
    createData('Office Hours', officeHours),
  ];

  leavesAvailed.forEach((leave) => {
    if (leave.applicationCount > 0) {
      rows.push(createData(leave.leaveName, leave.applicationCount));
    }
  });

  rows.push(
    createData('WFH Hours Reported', reportedWfhHours),
    createData('WFH Hours Approved', approvedWfhHours),
    createData('Remote Office Hours Pending', pendingRemoteOfficeHours),
    createData('Remote Office Hours Approved', approvedRemoteOfficeHours),
  );

  if (hasHours(externalHours)) {
    rows.push(createData('External Hours', externalHours));
  }
  if (hasHours(clientOfficeHours)) {
    rows.push(createData('Client Office Hours', clientOfficeHours));
  }
  if (hasHours(workTravelHours)) {
    rows.push(createData('Work Travel Hours', workTravelHours));
  }
  if (hasHours(weekendWorkingHours)) {
    rows.push(createData('Weekend Working Hours', weekendWorkingHours));
  }

  rows.push(
    createData(
      'Payroll Hours',
      totalHours ? (
        <>
          {totalHours} ({safeValue(payrollPercentage)} %)
          {payrollPercentage < 90 && (
            <>
              <ReportIcon
                fontSize="medium"
                sx={{
                  color: DARK_RED,
                  marginLeft: 1,
                }}
                id={'flag'}
                tabIndex="-1"
              />
              <ReactTooltip
                anchorId={'flag'}
                place="bottom"
                variant={ERROR_KEY}
                content={'Please complete the Expected Hours'}
                className="tooltip-style"
                style={{ background: DARK_RED }}
              />
            </>
          )}
        </>
      ) : (
        ''
      ),
    ),
  );

  return (
    <>
      <StandaloneToolbar onNavigate={onNavigate} label={label} />
      {loader ? (
        <GenericLoader
          rectAttributes={TimesheetsComponentLoaderAttribute}
          width={'100%'}
          height={350}
        />
      ) : (
        <Box sx={{ width: '100%', mt: 1 }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 300 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    style={{ backgroundColor: '#4d6cd9', width: '60%' }}
                  >
                    Work & Payroll Summary
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: '#4d6cd9', width: '40%' }}
                  >
                    {/* Hours */}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      style={{ width: '60%' }}
                    >
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '40%' }}>
                      {row.values}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};

export default WorkPayrollSummary;
